import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import '@/App.css';
import { AppProvider } from '@/contexts/AppContext';
import APEXShell from '@/components/apex/APEXShell';
import ScrollToTop from '@/components/ScrollToTop';
import Home from '@/pages/Home';
import CommandCenter from '@/pages/CommandCenter';
import Investigations from '@/pages/Investigations';
import IdentityProof from '@/pages/IdentityProof';
import ContainerGovernance from '@/pages/ContainerGovernance';
import EnvironmentIntegrity from '@/pages/EnvironmentIntegrity';
import ChangeLegitimacy from '@/pages/ChangeLegitimacy';
import MissingEvidence from '@/pages/MissingEvidence';
import Reconstruction from '@/pages/Reconstruction';
import AccountLandscape from '@/pages/AccountLandscape';
import AccountDetail from '@/pages/AccountDetail';
import GovernanceDebt from '@/pages/GovernanceDebt';
import Remediation from '@/pages/Remediation';
import Integrations from '@/pages/Integrations';
import EvidenceVault from '@/pages/EvidenceVault';
import AuditWorkspace from '@/pages/Audit';
import BoardReports from '@/pages/BoardReports';
import SharedBoard from '@/pages/SharedBoard';
import HowItWorks from '@/pages/HowItWorks';

// Landing pages (no APEXShell — full-bleed public-facing layout)
import WhyApex from '@/pages/landing/WhyApex';
import Platform from '@/pages/landing/Platform';
import ProductLens from '@/pages/landing/ProductLens';
import ProductTrust from '@/pages/landing/ProductTrust';
import Contact from '@/pages/landing/Contact';
import Privacy from '@/pages/landing/Privacy';
import LensGate from '@/components/landing/LensGate';
import CookieConsent from '@/components/CookieConsent';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppProvider>
          <ScrollToTop />
          <CookieConsent />
          <Routes>
            {/* ─── Landing routes — NO shell ─── */}
            <Route path="/" element={<Home />} />
            <Route path="/why-apex" element={<WhyApex />} />
            <Route path="/platform" element={<Platform />} />
            <Route path="/product/lens" element={<ProductLens />} />
            <Route path="/product/trust" element={<ProductTrust />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />

            {/* ─── Product routes — WITH shell + GATED ─── */}
            <Route element={<LensGate />}>
              <Route element={<APEXShell />}>
                <Route path="/lens" element={<CommandCenter />} />
                <Route path="/lens/investigations" element={<Investigations />} />
                <Route path="/lens/identity" element={<IdentityProof />} />
                <Route path="/lens/containers" element={<ContainerGovernance />} />
                <Route path="/lens/environment" element={<EnvironmentIntegrity />} />
                <Route path="/lens/changes" element={<ChangeLegitimacy />} />
                <Route path="/lens/missing-evidence" element={<MissingEvidence />} />
                <Route path="/lens/reconstruction" element={<Reconstruction />} />
                <Route path="/lens/accounts" element={<AccountLandscape />} />
                <Route path="/lens/accounts/:id" element={<AccountDetail />} />
                <Route path="/lens/debt" element={<GovernanceDebt />} />
                <Route path="/lens/remediation" element={<Remediation />} />
                <Route path="/lens/integrations" element={<Integrations />} />
                <Route path="/lens/evidence" element={<EvidenceVault />} />
                <Route path="/lens/audit" element={<AuditWorkspace />} />
                <Route path="/lens/how-it-works" element={<HowItWorks />} />
                <Route path="/reports" element={<BoardReports />} />
              </Route>
            </Route>

            {/* ─── /demo/* — gated, private design-partner URL requires ?access=APEX2026 ─── */}
            <Route element={<LensGate />}>
              <Route element={<APEXShell />}>
                <Route path="/demo" element={<CommandCenter />} />
                <Route path="/demo/lens" element={<CommandCenter />} />
                <Route path="/demo/investigations" element={<Investigations />} />
                <Route path="/demo/identity" element={<IdentityProof />} />
                <Route path="/demo/containers" element={<ContainerGovernance />} />
                <Route path="/demo/environment" element={<EnvironmentIntegrity />} />
                <Route path="/demo/changes" element={<ChangeLegitimacy />} />
                <Route path="/demo/missing-evidence" element={<MissingEvidence />} />
                <Route path="/demo/reconstruction" element={<Reconstruction />} />
                <Route path="/demo/accounts" element={<AccountLandscape />} />
                <Route path="/demo/accounts/:id" element={<AccountDetail />} />
                <Route path="/demo/debt" element={<GovernanceDebt />} />
                <Route path="/demo/remediation" element={<Remediation />} />
                <Route path="/demo/integrations" element={<Integrations />} />
                <Route path="/demo/evidence" element={<EvidenceVault />} />
                <Route path="/demo/audit" element={<AuditWorkspace />} />
                <Route path="/demo/how-it-works" element={<HowItWorks />} />
              </Route>
            </Route>

            <Route path="/share/board/:token" element={<SharedBoard />} />
          </Routes>
        </AppProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
